/*
 * HelloSpicy — « Complétez votre panier » : ajout rapide (audit A11).
 * Voir snippets/hs-complements.liquid.
 *
 * Page panier   → ajoute l'article puis remplace .js-contents de main-cart-items
 *                 (lignes + liste de suggestions) et de main-cart-footer (total),
 *                 le tout en UNE requête grâce au paramètre `sections` de /cart/add.js.
 * Notification  → ajoute l'article puis re-rend la section hs-complements (barre
 *                 de livraison compacte + suggestions restantes) et la pastille panier.
 * Dans les deux cas, l'événement Dawn `cart-update` est publié : la barre de
 * livraison du haut de page et l'estimateur de frais se mettent à jour.
 */
(function () {
  'use strict';

  function innerFrom(html, selector) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function remplacer(cible, html) {
    if (cible && html !== null && html !== undefined) cible.innerHTML = html;
  }

  function ajouter(form) {
    var bloc = form.closest('[data-hs-complements]');
    var contexte = bloc ? bloc.getAttribute('data-contexte') : 'panier';
    var bouton = form.querySelector('button[type="submit"]');
    var erreur = bloc ? bloc.querySelector('[data-hs-compl-erreur]') : null;
    var id = parseInt(form.querySelector('input[name="id"]').value, 10);

    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var sections = ['cart-icon-bubble'];
    if (contexte === 'panier' && itemsEl && itemsEl.dataset.id) {
      sections.push(itemsEl.dataset.id);
      if (footerEl && footerEl.dataset.id) sections.push(footerEl.dataset.id);
    } else {
      sections.push('hs-complements');
    }

    if (bouton) { bouton.disabled = true; bouton.setAttribute('aria-busy', 'true'); }
    if (erreur) { erreur.hidden = true; erreur.textContent = ''; }

    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          throw new Error(res.j.description || res.j.message || (window.cartStrings && window.cartStrings.error) || 'Erreur');
        }
        var s = res.j.sections || {};
        remplacer(document.getElementById('cart-icon-bubble'), innerFrom(s['cart-icon-bubble'], '.shopify-section'));
        if (contexte === 'panier' && itemsEl) {
          remplacer(itemsEl.querySelector('.js-contents'), innerFrom(s[itemsEl.dataset.id], '.js-contents'));
          remplacer(document.querySelector('[data-hs-compl-panier]'), innerFrom(s[itemsEl.dataset.id], '[data-hs-compl-panier]'));
          if (footerEl) remplacer(footerEl.querySelector('.js-contents'), innerFrom(s[footerEl.dataset.id], '.js-contents'));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            // source 'cart-items' : les lignes viennent d'être re-rendues, inutile que CartItems recharge.
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: id, hsComplements: true });
          }
        } else {
          remplacer(document.getElementById('hs-complements'), innerFrom(s['hs-complements'], '.shopify-section'));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hs-complements', productVariantId: id });
          }
        }
      })
      .catch(function (e) {
        if (erreur) { erreur.textContent = e.message; erreur.hidden = false; }
        if (bouton) { bouton.disabled = false; bouton.removeAttribute('aria-busy'); }
      });
  }

  // Page panier : après toute modification (quantité, suppression, ajout ailleurs),
  // la liste de suggestions est relue depuis la section main-cart-items.
  function rafraichirPanier() {
    var bloc = document.querySelector('[data-hs-compl-panier]');
    var itemsEl = document.getElementById('main-cart-items');
    if (!bloc || !itemsEl || !itemsEl.dataset.id) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?section_id=' + itemsEl.dataset.id, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { remplacer(bloc, innerFrom(html, '[data-hs-compl-panier]')); })
      .catch(function () {});
  }
  function abonner() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.hsComplements) return;
        rafraichirPanier();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abonner, { once: true });
  else abonner();

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-hs-compl-add]')) return;
    e.preventDefault();
    ajouter(form);
  });
})();
